// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:55:04
import { CTacticalSituationTemplate_abstract } from './../abstract/SagaSchema/CTacticalSituationTemplate_abstract';
export class CTacticalSituationTemplate extends CTacticalSituationTemplate_abstract {}
